export type Props = {
  index: number
  length: number
}

export const isSuitableExtraDataMethod = (method: string): boolean =>
  method === 'fs_finalize_userplace' || method === 'np_userplace_adjust'
